export enum Goals {
  LOGIN = 'IHBJQCC0',
  CREATE_NEW_STORY = 'WYESYDDJ',
  PUBLISH = 'PYKUM6ZG',
}
